import React, { Fragment, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link, useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import { logoutUser } from "../../../actions/authActions";

import { useAlert } from "react-alert";
import Loader from "../../Loader";
// import '../../../assets/admin/plugins/fontawesome-free/css/all.min.css';
import '../../../assets/admin/dist/css/adminlte.min.css';
// import '../../../assets/admin/dist/css/_all-skins.min.css';
import './Header.css';

const Header = () => {
    const alert = useAlert();
    const dispatch = useDispatch();
    const history = useHistory();

    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);

    const { user, loading } = useSelector((state) => state.auth);

    const logoutHandler = () => {
        dispatch(logoutUser());
        history.push("/admin/login");
        alert.success("Logout successfully.");
    };

    const openLogoutModal = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        setIsUserMenuOpen(false);
        setShowLogoutModal(true);
    };

    const closeLogoutModal = () => {
        setShowLogoutModal(false);
    };

    const confirmLogout = () => {
        setShowLogoutModal(false);
        logoutHandler();
    };

    const toggleUserMenu = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        setIsUserMenuOpen((v) => !v);
    };

    useEffect(() => {
        if (!isUserMenuOpen) return;

        const handleDocMouseDown = (event) => {
            const target = event.target;
            if (!userMenuRef.current) return;
            if (userMenuRef.current.contains(target)) return;
            setIsUserMenuOpen(false);
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsUserMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleDocMouseDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handleDocMouseDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isUserMenuOpen]);

    useEffect(() => {
        if (!showLogoutModal) return;
        document.body.classList.add('modal-open');
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [showLogoutModal]);

    return (
        <Fragment>
            {loading ? (
                <Loader />
            ) : (
                <Fragment>
                    <header className="main-header">

                        <Link to="/admin" className="admin-logo">

                            <span className="logo-mini"><b>O</b>TS</span>

                            <span className="logo-lg">One Time Success</span>
                        </Link>
                        <nav className="navbar navbar-static-top">
                            <Link to="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
                                <span className="sr-only">Toggle navigation</span>
                            </Link>

                            <div className="navbar-custom-menu">
                                <ul className="nav navbar-nav">

                                    <li ref={userMenuRef} className={`dropdown user user-menu${isUserMenuOpen ? ' open' : ''}`}>
                                        <Link to="#" className="dropdown-toggle" onClick={toggleUserMenu}>
                                            <img src={process.env.REACT_APP_PUBLIC_URL + "/assets/img/user.png"} className="user-image" alt="User Image"/>
                                            {/*<span className="hidden-xs">{`${user.first_name} ${user.last_name}`}</span>*/}
                                        </Link>
                                        <ul className="dropdown-menu" style={{ display: isUserMenuOpen ? 'block' : 'none' }}>
                                            <li className="user-header">
                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/assets/img/user.png"} className="img-circle" alt="User Image"/>

                                                {/*<p>
                                            Alexander Pierce - Web Developer
                                            <small>Member since Nov. 2012</small>
                                        </p>*/}
                                            </li>
                                            {/*<li className="user-body">
                                    <div className="row">
                                        <div className="col-xs-4 text-center">
                                            <a href="#">Followers</a>
                                        </div>
                                        <div className="col-xs-4 text-center">
                                            <a href="#">Sales</a>
                                        </div>
                                        <div className="col-xs-4 text-center">
                                            <a href="#">Friends</a>
                                        </div>
                                    </div>
                                </li>*/}

                                            <li className="user-footer">
                                                <div className="pull-left">
                                                    <a href="#" className="btn btn-default btn-flat">Profile</a>
                                                </div>
                                                <div className="pull-right">

                                                    <button type="button" className="btn btn-default btn-flat" onClick={openLogoutModal}>
                                                        Logout
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    {/*<li>
                            <a href="#" data-toggle="control-sidebar"><i className="fa fa-gears"></i></a>
                        </li>*/}
                                </ul>
                            </div>
                        </nav>
                    </header>

                    {showLogoutModal
                        ? createPortal(
                              <Fragment>
                                  <div
                                      role="dialog"
                                      aria-modal="true"
                                      aria-label="Confirm logout"
                                      style={{
                                          position: 'fixed',
                                          top: 0,
                                          right: 0,
                                          bottom: 0,
                                          left: 0,
                                          backgroundColor: 'rgba(0,0,0,0.5)',
                                          zIndex: 9999,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          padding: 16,
                                      }}
                                      onClick={closeLogoutModal}>
                                      <div
                                          role="document"
                                          style={{
                                              width: '100%',
                                              maxWidth: 420,
                                              backgroundColor: '#fff',
                                              border: '1px solid #ddd',
                                          }}
                                          onClick={(e) => e.stopPropagation()}>
                                          <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
                                              <button
                                                  type="button"
                                                  className="close"
                                                  aria-label="Close"
                                                  onClick={closeLogoutModal}
                                                  style={{ float: 'right' }}>
                                                  <span aria-hidden="true">×</span>
                                              </button>
                                              <h4 style={{ margin: 0 }}>Confirm Logout</h4>
                                          </div>
                                          <div style={{ padding: '14px 16px' }}>
                                              <p style={{ margin: 0 }}>Are you sure you want to log out?</p>
                                          </div>
                                          <div
                                              style={{
                                                  padding: '12px 16px',
                                                  borderTop: '1px solid #eee',
                                                  display: 'flex',
                                                  justifyContent: 'flex-end',
                                                  gap: 8,
                                              }}>
                                              <button type="button" className="btn btn-default" onClick={closeLogoutModal}>
                                                  Cancel
                                              </button>
                                              <button type="button" className="btn btn-primary" onClick={confirmLogout}>
                                                  Logout
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </Fragment>,
                              document.body,
                          )
                        : null}
                </Fragment>
            )}
        </Fragment>

    );
}

export default Header;